module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "file-upload-form"
  }, [_c('input', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.selectedFile
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57ad3296"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/FIleUpload.vue
// module id = 460
// module chunks = 1